import * as React from 'react'

import { Box, Button, useToggle } from '@factorialco/deprecated-design-system'
import { ShiftManagementTemplateFragment } from 'generated/resources/graphql'

import Popover from 'modules/core/components/Popover'
import PopoverContent from 'modules/core/components/Popover/Content'
import type { Option } from 'modules/core/components/Popover/Content'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import DeleteShiftTemplate from 'modules/shift_management/components/Settings/ShiftTemplates/Content/DeleteShiftTemplate'

interface Props {
  shiftTemplate: ShiftManagementTemplateFragment
}

const Settings = ({ shiftTemplate }: Props) => {
  const [open, toggle] = useToggle()
  const [isModalOpen, setIsModalOpen] = React.useState(false)
  const { navigation } = useNavigation()

  const popoverOptions = () => {
    const options: Option[] = [
      {
        title: i18n.t('shift_management.rotating_shifts.edit_shift'),
        to: navigation.shifts.templates.templatesShiftTemplateId.edit.fullPath({
          shiftTemplateId: shiftTemplate.id,
        }),
      },
      {
        title: i18n.t('shift_management.rotating_shifts.delete_shift'),
        onClick: () => setIsModalOpen(true),
        type: 'wrong',
      },
    ]

    return options
  }

  return (
    <>
      <Box flexDirection="row" gap="s8">
        <Popover
          attachment="top right"
          targetAttachment="bottom center"
          toggle={toggle}
          open={open}
        >
          <Button type="secondary" iconName="ellipsis" />
          <PopoverContent onClose={toggle(false)} options={popoverOptions()} />
        </Popover>
        {isModalOpen && (
          <DeleteShiftTemplate
            shiftTemplate={shiftTemplate}
            onCancel={() => setIsModalOpen(false)}
          />
        )}
      </Box>
    </>
  )
}

export default Settings
